namespace GeniuzPOS.InitialData {
    export interface PsConnectEdcBankForm {
        EdcBank: Serenity.StringEditor;
        EdcBankName: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
    }

    export class PsConnectEdcBankForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsConnectEdcBank';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsConnectEdcBankForm.init)  {
                PsConnectEdcBankForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsConnectEdcBankForm, [
                    'EdcBank', w0,
                    'EdcBankName', w0,
                    'Remark', w0
                ]);
            }
        }
    }
}
